import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type Tag = WithLegacy<{
  label: string | null;
  itemCount: number | null;
  createdAt: string | null;
  [Type]: 'tags';
}>;

export const TagSchema = withDefaults({
  type: 'tags',
  fields: [
    { name: 'label', kind: 'attribute', type: 'string' },
    { name: 'itemCount', kind: 'attribute', type: 'number' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
  ],
});
